import { isPlatformBrowser } from '@angular/common';
import { ClassProvider, FactoryProvider, Injectable, InjectionToken, PLATFORM_ID } from '@angular/core';
import { ConfigurationManagerService } from './configuration-manager.service';
import { ApiService } from './api-old.service';
import { FormGroup } from '@angular/forms';

export const WINDOW = new InjectionToken('WindowToken');

export abstract class WindowRef {
  get nativeWindow(): Window | Object {
    throw new Error('Not implemented.');
  }
}

export class BrowserWindowRef extends WindowRef {

  constructor() {
    super();
  }

  override get nativeWindow(): Window | Object {
    return window;
  }
}

/* Create an factory function that returns the native window object. */
export function windowFactory(browserWindowRef: BrowserWindowRef, platformId: Object): Window | Object {
  if (isPlatformBrowser(platformId)) {
    return browserWindowRef.nativeWindow;
  }
  return new Object();
}

/* Create a injectable provider for the WindowRef token that uses the BrowserWindowRef class. */
const browserWindowProvider: ClassProvider = {
  provide: WindowRef,
  useClass: BrowserWindowRef
};

/* Create an injectable provider that uses the windowFactory function for returning the native window object. */
const windowProvider: FactoryProvider = {
  provide: WINDOW,
  useFactory: windowFactory,
  deps: [WindowRef, PLATFORM_ID]
};

/* Create an array of providers. */
export const WINDOW_PROVIDERS = [
  browserWindowProvider,
  windowProvider
];

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(private apiService: ApiService) {

  }


  //Validate Form elements on submit
  ValidateAllFormFields(form: any) {

    var controls = form.controls;
    var controlKeys = Object.keys(form.controls);
    controlKeys.forEach(function (value) {

      controls[value].markAsTouched();
    });
    this.scrollIfFormHasErrors(form).then(() => {
      // Run any additional functionality if you need to. 
    });
  };

  //scrolls to error box
  async scrollIfFormHasErrors(form: FormGroup): Promise<any> {
    await form.invalid;
    this.scrollToError();
  }
  //scrolls to error box
  scrollToError(): void {
    const firstElementWithError = Array.from(document.querySelectorAll('.ng-invalid'));
    let selected = "";
    firstElementWithError.forEach(function (value) {
      if (selected == "") {
        selected = value.id;
      }
      if (selected != "") {
        var cb = document.getElementById(selected)
        if (cb != null) {
          cb.focus();
        }
      }
    });
  }
  login(username: string, password: any) {

    // request
    return this.apiService.httpLoginget(ConfigurationManagerService.settings.BaseURL + ConfigurationManagerService.settings.Login, username, password);
  }
  requestActionSessionWithOrganizationIds(){
    const params = {
      attributes: ['code'],
      where: { code: 'arclive' }
  };
    return this.apiService.post(ConfigurationManagerService.settings.BaseURL + ConfigurationManagerService.settings.ActionSessionWithOrganizationIds, params);
  }
  //Get Plan
  ForgotPassword(emailID: string) {
    var request: any = {
      email: emailID
    }
    return this.apiService.post(ConfigurationManagerService.settings.BaseURL + ConfigurationManagerService.settings.ForgotPassword, request);
  }

  ResetPassword(emailID: string, verificationCode: string,password: string,verifyPassword: string ) {
    var request: any = {
      verificationCode: verificationCode,
      userEmail: emailID,
      password: password,
      verifyPassword: verifyPassword
    }
    return this.apiService.post(ConfigurationManagerService.settings.BaseURL + ConfigurationManagerService.settings.ResetPassword, request);
  }

  jwt_decode(token: string): any {
    if (!token) return null;
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    try {
      const payload = parts[1].replace(/-/g, '+').replace(/_/g, '/');
      const decoded = atob(payload);
      return JSON.parse(decoded);
    } catch (e) {
      return null;
    }
  }
}
